const ACTIVE_CLASS = 'mobile-menu--active'
const body = document.body
const wrapper = document.querySelector('.mobile-menu-wrapper')
const input = document.querySelector('#mobile-menu-input')

export function toggleMenuActive() {
    body.classList.toggle(ACTIVE_CLASS, input.checked)
}

export function manageMobileMenu() {

    if(!wrapper) {
        return
    }
    if(!input) {
        throw `The input is required for the mobile menu to work. Try placing this at the top of the body element. <input id="mobile-menu-input" type="checkbox" />`
    }

    // This is added when JS loads not in CSS to prevent a flash on load.
    wrapper.classList.add('mobile-menu-wrapper--transition')

    input.addEventListener('change', toggleMenuActive)
}
